export default "__VITE_ASSET__D4lMz9XN__"